import React, { useEffect, useState } from 'react';
import Select, { components, MenuPlacement } from "react-select";
import { Center, Column, VerticallyCenteredRow } from "../atoms/StructuralLayout";
import { UserAvatarAndName } from "./UserAvatarAndName";
import { BodyRegular, BodySmall } from "../atoms/fonts/Body";
import Colours from "../atoms/Colours";
import { findUserRequest } from '@features/settings/services/UserService';
import { BasicUserInfo } from '@shared/models/user.models';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { DROP_DOWN_STYLES, PORTAL_DROP_DOWN_STYLES } from "../organisms/drop-down-list/DropDownStyles";

export function UserSearchDropDownList(props: Props) {
  const [selected, setSelected] = useState<any>(null);
  const [options, setOptions] = useState<any>([]);
  const [inputValue, setInputValue] = useState('');
  const {t} = useTranslation();

  const onInputChange = async (query: string, selectUserId?: string) => {
    setInputValue(query)
    if (query.length < 3) return

    try {
      const searchResponse = await findUserRequest(query);
      const parsedOptions = searchResponse.map((userInfo: BasicUserInfo) => ({...userInfo, value: userInfo.userId, label: `${userInfo.firstName} ${userInfo.lastName}`}));
      setOptions(parsedOptions);

      if (selectUserId) {
        const selectedUser = searchResponse.find((u: any) => u.userId === selectUserId);
        if (selectedUser) {
          setSelected(selectedUser);
        }
      }
    } catch (err: any) {
      setOptions([]);
    }
  }

  const CustomOption = (props: any) => {
    return (
      <UserDropDownItem {...props.innerProps}>
        <Column style={{padding: '4px 2px'}}>
          <VerticallyCenteredRow>
            <UserAvatarAndName firstName={props.data.firstName} lastName={props.data.lastName} hideName={true} />
            <BodyRegular style={{padding: '4px 0 4px 12px'}}>{props.data.firstName} {props.data.lastName}</BodyRegular>
          </VerticallyCenteredRow>
          <BodySmall style={{marginLeft: 44, marginTop: -4}} colour={Colours.darkGrey}>{props.data.teamName ?? t('general.no-team')}</BodySmall>
        </Column>
      </UserDropDownItem>
    );
  }

  const DropdownIndicatorComp = components.DropdownIndicator as any;
  const CustomDropdownIndicator = (props: any) => {
    return (
      <DropdownIndicatorComp {...props}>

        {props.hasValue ? <Center style={{padding: '0 8px', cursor: 'pointer'}} onClick={() => props.clearValue()}>
          <i className="icon-Close" />
        </Center> : <Center style={{padding: '0 8px'}}>
          <i className="icon-Search" />
        </Center>}
      </DropdownIndicatorComp>
    );
  }

  const onSelect = (selectedUser: BasicUserInfo) => {
    setSelected(selectedUser);
    props.onSelect(selectedUser);
  }

  useEffect(() => {
    if (props.presetSearch) {
      onInputChange(props.presetSearch, props.presetUserId);
    }
  }, [props.presetSearch, props.presetUserId]);

  return (
    <>
      <Select
        styles={props.portalMenu ? PORTAL_DROP_DOWN_STYLES : DROP_DOWN_STYLES}
        menuPortalTarget={props.portalMenu ? document.body : undefined}
        value={selected}
        inputValue={inputValue}
        placeholder={t('textinput.find-user')}
        onInputChange={(value: string) => onInputChange(value)}
        options={options} isDisabled={!!props?.disabled}
        closeMenuOnSelect={props.closeOnSelect}
        menuPlacement={(props?.menuPlacement ?? 'auto') as MenuPlacement}

        components={{
          Option: CustomOption,
          DropdownIndicator: CustomDropdownIndicator,
        }}
        onChange={(selectedUser: any) => onSelect(selectedUser)}
      />
    </>
  )
}

interface Props {
  closeOnSelect: boolean;
  onSelect: (user: BasicUserInfo) => any;
  disabled?: boolean;
  presetSearch?: string;
  presetUserId?: string;
  menuPlacement?: MenuPlacement;
  /** Render the menu into the body, for a dropdown inside a dialog or other clipping container. */
  portalMenu?: boolean;
}

const UserDropDownItem = styled.div`
  cursor: pointer;
  padding: 0 16px 0 4px;
  &:hover {
    background-color: ${Colours.blue10};
  }
`
